/* import __COLOCATED_TEMPLATE__ from './tap-tile-grid.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./tap-tile-grid.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  classNames: ["tap-tile-grid"],
  activeTile: null
}));